import React, { useEffect, useState } from "react";
import { Container, Grid, Button, AppBar, IconButton, Toolbar, Collapse, MenuList, Stack, List, ListItem, Card, Divider, Box, FormGroup, useScrollTrigger, OutlinedInput, FormLabel, TableContainer, TableRow, Table, TableCell, TableBody } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Shared/Logo";
import ConsentScripts from "../../utils/ConsentScripts";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import PricingBoxes from "../Shared/PricingBoxes";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import Austria from 'images/austria.png';
import Europe from 'images/eu.png';
import DashboardImage from 'images/dashboard.jpg';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import i18n from "i18next";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const Landingpage = () => {
  const [menuShown, showMenu] = useState<boolean>(false);
  const [employees, setEmployees] = useState<number>(150);
  const [salesRate, setSalesRate] = useState<number>(75);
  const [savings, setSavings] = useState<number>(0);
  const [roi, setRoi] = useState<number>();

  useEffect(() => {
    const costs = employees * 1600 * salesRate * 0.025;
    const licenseCosts = employees * 10 * 12;
    const savingRate = costs * 0.25;
    setSavings(savingRate);

    const multiplier = Math.pow(10, 2);
    const roundedRoi = Math.round((licenseCosts/savingRate * 12) * multiplier) / multiplier;

    setRoi(roundedRoi);
  }, [employees, salesRate]);

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window,
  });

  const MenuItems = (props) => {
    return (
      <MenuList
        sx={{
          display: props.responsive ? { xs: "none", md: "flex" } : "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "center" },
          gap: { sx: 1, md: 2 },
          flexGrow: 1,
        }}
      >
        {/* <Button fullWidth={!props.responsive}>
          Features
        </Button>
        <Button fullWidth={!props.responsive}>
          Use Cases
        </Button>
        <Button fullWidth={!props.responsive}>
          Pricing
        </Button>
        <Button fullWidth={!props.responsive}>
          FAQ
        </Button> */}

        <Stack
          direction="row"
          sx={{ marginLeft: "auto", display: { xs: "none", md: "flex" } }}
          spacing={1}
        >
          <Button
            variant="text"
            color="primary"
            size="small"
            component={NavLink}
            to="/login"
            sx={{['&:hover']: { backgroundColor: 'transparent !important' }}}
          >
            <span className={trigger ? "text-primary" : "text-white"}>Sign in</span>
          </Button>
          <Button
            component={NavLink}
            variant="text"
            color="secondary"
            size="small"
            to="/signup"
            sx={{['&:hover']: { backgroundColor: 'transparent !important' }}}
          >
            <span className={trigger ? "text-primary" : "text-white"}>Create workspace</span>
          </Button>
        </Stack>

        <Button
          component={NavLink}
          to="/login"
          sx={{ display: { md: "none" } }}
          fullWidth
        >
          Sign in
        </Button>

        <Button
          component={NavLink}
          to="/signup"
          sx={{ display: { md: "none" } }}
          fullWidth
        >
          Create workspace
        </Button>
      </MenuList>
    );
  };

  return <>
    <ConsentScripts />

    <AppBar component="nav" position="fixed" sx={{ background: trigger ? "rgba(250, 251, 251, 0.8) !important" : "transparent", boxShadow: trigger ? "var(--box-shadow-flat) !important" : "none" }}>
      <Toolbar sx={{ gap: "3rem" }}>
        <Logo color={trigger ? "primary" : "white"} />
        <IconButton
          sx={{ marginLeft: "auto", display: { md: "none" } }}
          onClick={() => showMenu((shown) => !shown)}
          color={trigger ? "primary" : "secondary"}
        >
          <MenuIcon />
        </IconButton>
        <MenuItems responsive />
      </Toolbar>
    </AppBar>

    <Collapse
      in={menuShown}
      className="bg-white"
      sx={{ position: "fixed", width: "100%", top: "56px", zIndex: 1, boxShadow: "var(--box-shadow-flat)", display: { md: "none" } }}
    >
      <MenuItems />
    </Collapse>

    <header className="bg-mesh" style={{ minHeight: "120vh", paddingTop: "8rem", overflow: "hidden" }}>
      <Container maxWidth="lg" className="text-center" sx={{position: "relative"}}>
        
        <Box className="animate__animated animate__fadeIn" sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          <Box sx={{[`> h1`]: { fontSize: { md: "3.5rem", sm: "3rem", xs: "2.5rem" } } }}><h1 className="text-white text-special">Make better decisions from your lessons learned process, reduce company mistake rate by 25%</h1></Box>
          <h3 className="text-white text-light text-special" style={{opacity: 0.75, maxWidth: "75%"}}>
            We convert lessons learned into data driven dashboards that help identifying blind spots and trends for real business impact.
          </h3>
        </Box>

        <Stack direction="row" spacing={2} sx={{mt: 4, pb: 5, justifyContent: "center", zIndex: 1, position: "relative"}} className="animate__animated animate__fadeInUp">
          {/* <Button
            variant="outlined"
            color="secondary"
            size="large"
            component={Link}
            to="https://calendly.com/office-lessonice/demo"
            target="_blank"
            sx={{color: 'var(--color-white) !important', bgcolor: "transparent !important", borderColor: 'var(--color-white) !important' }}
          >
            Book a demo
          </Button> */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            component={NavLink}
            to="/signup"
            endIcon={<ArrowRightAltIcon />}
            sx={{display: {xs: "none", sm: "inline-flex"}}}
          >
            Try out now
          </Button>
        </Stack>

        <Box sx={{ 
          position: "absolute", 
          right: "-20%", 
          left: "20%",
          top: "25rem", 
          transform: "skew(15deg, -12deg)",
          maskImage: "linear-gradient(to bottom right, black 20%, transparent 110%)",
          border: "2px solid var(--color-greyLight)",
          borderRadius: "var(--border-radius-button)",
          padding: 3.5,
          boxShadow: "var(--box-shadow-flat)",
          display: { xs: "none", md: "block" },
          zIndex: 0
        }}>
          <img style={{width: "100%", height: "100%", borderRadius: 'var(--border-radius)', display: 'block'}} src={DashboardImage} alt="Data driven dashboard" />
        </Box>

        <Box sx={{ 
          mt: 5,
          padding: 1,
          border: "1px solid var(--color-greyLight)",
          borderRadius: "var(--border-radius)",
          boxShadow: "var(--box-shadow-flat)",
          display: { xs: "block", md: "none" }
        }}
          className="animate__animated animate__fadeInUp">
          <img style={{width: "100%", height: "100%", borderRadius: 'var(--border-radius-item)', display: 'block'}} src={DashboardImage} alt="Data driven dashboard" />
        </Box>

      </Container>
    </header>

    <section className="bg-white" style={{ padding: "7rem 0 5rem" }}>
      <Container maxWidth="lg" className="text-center">
        <h3 className="text-info text-uppercase text-light">Transforming lessons learned into success</h3>
        <h1 style={{marginTop: '1rem'}}>&#x201C;Imagine getting the big picture of every mistake your team makes <span className="text-secondary">- objectively, in real time.&#x201D;</span></h1>
      </Container>
    </section>

    <Divider />

    <section className="bg-white" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{xs: 12, md: 6}}>
            <h3 className="text-info text-uppercase text-light">Projects end, people leave, insights vanish</h3>
            <h1 style={{margin: "1rem 0"}}>Is your lessons learned process leading nowhere?</h1>
            <List>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <GppMaybeOutlinedIcon color="secondary" sx={{mt: 0.9}} /> <h2 className="text-light text-secondary">You are not alone. Many companies conduct end-of-project retros that are barely sufficient.</h2>
              </ListItem>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <GppMaybeOutlinedIcon color="secondary" sx={{mt: 0.9}} /> <h2 className="text-light text-secondary">Ending in slides and spreadsheets nobody reads.</h2>
              </ListItem>
              <ListItem sx={{p: "0.5rem 0", gap: 1}} alignItems="flex-start">
                <GppMaybeOutlinedIcon color="secondary" sx={{mt: 0.9}} /> <h2 className="text-light text-secondary">Just to see the same mistakes coming back.</h2>
              </ListItem>
            </List>
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
          </Grid>
        </Grid>      
      </Container>
    </section>

    <section className="bg-secondary" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          
          <Grid size={{xs: 12, md: 7}}>
            <h3 className="text-info text-uppercase text-light" style={{marginTop: "3rem"}}>Let's figure out how much your enterprise loses on avoidable mistakes</h3>
            <h1 style={{margin: "1rem 0"}}>Save <strong>{i18n.t('currency_label', { val: savings / 12, maximumFractionDigits: 0 })}</strong> monthly</h1>
            <h3 className="text-light text-secondary" style={{margin: "1.5rem 0 2.5rem 0"}}>Fill in your actual numbers in the ROI calculator to get an individual estimate. The result is based on the assumption that</h3>
            
            <Grid container spacing={3}>
              <Grid size={6}>
                <h2 className="text-lg" style={{marginBottom: 0}}>~1 hour</h2>
                <h3 className="text-secondary text-light"><span className="text-primary">per employee</span> / week is lost on average due to avoidable mistakes.</h3>
              </Grid>

              <Grid size={6}>
                <h2 className="text-lg" style={{marginBottom: 0}}>-25%</h2>
                <h3 className="text-secondary text-light"><span className="text-primary">mistake reduction</span> if Lessonice supports your decision making.</h3>
              </Grid>
            </Grid>
          </Grid>

          <Grid size={{xs: 12, md: 5}}>
            <Card className="text-center">
              <FormGroup sx={{mb: 2}}><h2 className="text-info text-light">Return on Investment</h2></FormGroup>
              <FormGroup>
                <Grid container spacing={1}>
                  <Grid size={{xs: 12, md: 6}} textAlign="left" alignContent="center">
                    <FormLabel><span className="text-special">Number of employees</span></FormLabel>
                  </Grid>
                  <Grid size={{xs: 12, md: 6}}><OutlinedInput
                                value={employees} 
                                onChange={e => setEmployees(Number(e.target.value))}
                                type="number" 
                                startAdornment={<Diversity3Icon color="secondary" />}
                                sx={{gap: 1}} /></Grid>
                </Grid>
              </FormGroup>
              <FormGroup>
                <Grid container spacing={1}>
                  <Grid size={{xs: 12, md: 6}} textAlign="left" alignContent="center">
                    <FormLabel><span className="text-special">Average sales rate per employee</span></FormLabel>
                  </Grid>
                  <Grid size={{xs: 12, md: 6}}><OutlinedInput 
                                value={salesRate} 
                                onChange={e => setSalesRate(Number(e.target.value))}
                                type="number" 
                                startAdornment={<RequestQuoteIcon color="secondary" />}
                                /></Grid>
                </Grid>
              </FormGroup>

              <Divider sx={{mt: 2, mb: 3}} />

              <FormGroup>
                <h3 className="text-light">Return on Investment</h3>
                <h2><strong>after {roi ?? "-"} months</strong></h2>
              </FormGroup>

              <Divider sx={{mb: 2}} />

              <p className="text-secondary" style={{textAlign: "left", fontSize: "0.7rem"}}>*based on 1 lost hour per employee / week and a {i18n.t('currency_label', { val: 10, maximumFractionDigits: 0 })} per-seat license calculation.</p>
            </Card>
          </Grid>

        </Grid>      
      </Container>
    </section>

    <section style={{padding: "7rem 0 0"}} className="bg-white" data-nosnippet>
      <Container maxWidth="lg">
        <FormGroup sx={{mb: 3}}>
          <h1 className="text-special text-center">Lessonice compared to other AI assistants</h1>
          <h3 className="text-light text-special text-secondary text-center">Here's how Lessonice compares to ChatGPT and Copilot.</h3>
        </FormGroup>

        <TableContainer sx={{mt: 5}}>
          <Table>
            <TableBody sx={{["td"]: { borderColor: "var(--color-purpleLight)"}}}>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="center" className="bg-info" sx={{pt: 3, borderTopLeftRadius: "var(--border-radius-button)", borderTopRightRadius: "var(--border-radius-button)"}}><h2>Lessonice</h2></TableCell>
                <TableCell align="center" sx={{pt: 3}}><h2 className="text-light">ChatGPT</h2></TableCell>
                <TableCell align="center" sx={{pt: 3}}><h2 className="text-light">Copilot</h2></TableCell>
              </TableRow>

              { featureTable.map((feature, index) => {

                const iconify = (value: string) => {
                  if (value === "Y") {
                    return <CheckIcon color="info" />;
                  }
                  if (value === "N") {
                    return <CloseIcon color="primary" />;
                  }
                  return <span className="text-primary">{value}</span>;
                }

                return <TableRow>
                  <TableCell><h3 className="text-light text-secondary">{feature.criteria}</h3></TableCell>
                  <TableCell align="center" className="bg-info"><FormLabel>{iconify(feature.lessonice)}</FormLabel></TableCell>
                  <TableCell align="center"><FormLabel>{iconify(feature.chatgpt)}</FormLabel></TableCell>
                  <TableCell align="center"><FormLabel>{iconify(feature.copilot)}</FormLabel></TableCell>
                </TableRow>
              })}
              <TableRow sx={{["td"]: { border: "none" }}}>
                <TableCell></TableCell>
                <TableCell align="center" className="bg-info"></TableCell>
                <TableCell align="center"></TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </section>

    <section style={{padding: "7rem 0"}} className="bg-white" data-nosnippet>
      <Container maxWidth="lg">
        <Card className="bg-mesh text-center" sx={{padding: "5rem !important"}}>
          <FormGroup sx={{mb: 3}}>
            <h1 className="text-white text-special">Book your personal demo</h1>
            <h2 className="text-white text-light text-special">Get your lessons learned to the next level</h2>
          </FormGroup>

          <Button
            variant="contained"
            color="primary"
            size="large"
            component={Link}
            to="https://calendly.com/office-lessonice/demo"
            target="_blank"
            startIcon={<EventAvailableIcon />}
          >
            Book a demo
          </Button>
        </Card>
      </Container>
    </section>

    {/* <section id="pricing" className="bg-secondary" style={{ padding: "7rem 0" }}>
      <Container maxWidth="lg">
        <FormGroup className="text-center" sx={{mb: 3}}>
          <h3 className="text-info text-uppercase text-light">Our prices scale with your business</h3>
          <h1 className="text-center text-primary">Flexible Pricing</h1>
        </FormGroup>
        <PricingBoxes />
      </Container>
    </section> */}

    <footer className="bg-black" style={{ padding: "3rem 0" }} data-nosnippet>
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <p className="text-secondary text-uppercase text-light">Frequently asked questions</p>
        <h2 className="text-white text-lg text-special">Your concerns are important to us</h2>

        <Grid container spacing={5} sx={{mt: 5}}>
          <Grid size={{xs: 12, md: 6}}>
            <List>
              <FaqItem question="Will Lessonice use our data to train AI models?" answer="We won't use any of your data to train our AI models withouth your explicit consent. You can send us feedback anytime in order to optimize our algorithms. Any kind of info you voluntarily want to provide us together with your feedback is appreciated but not necessarily needed to be used to fine-tune our models." />
              <FaqItem question="Where is my company data hosted?" answer="Lessonice services are securely hosted on servers in the European Union that align with the highest safety and encryption standards." />
              <FaqItem question="What data does Lessonice access?" answer="We comply with the General Data Protection Regulation (GDPR) and the AI Act. Any kind of data in our system is consented and released by the users. In accordance with the GDPR, this data can be requested to be reviewed or removed at any time. This applies to all our services on offer." />
              <FaqItem question="How do you ensure that no company secrets are revealed?" answer="We give our best efforts to assure your data not being leaked or breached by any means. Nevertheless, any system can only be as conscientious and secure as its users. We endeavor to implement appropriate security precautions in line with the latest state of the art security measures to avoid any inconveniences." />
            </List>
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <List>
              <FaqItem question="What's the difference between Lessonice and ChatGPT?" answer="ChatGPT is an AI chatbot designed to engage in interactive conversations covering a wide range of different topics. However, ChatGPT does not have access to your company data. Lessonice in turn is a business software focused on sharing and discovering lessons learned, insights, and knowledge. It provides a structured way to document and retrieve company related data." />
              <FaqItem question="What's the difference between Lessonice and Microsoft Copilot?" answer="Microsoft Copilot is an AI assistant deeply integrated into the Microsoft ecosystem to enhance productivity. Lessonice as such enables enterprises to combine their knowledge in a more encapsulated way, so that not everything and every data is around that should not be there. As an enterprise-ready solution, Lessonice offers more opportunities to share knowledge on point." />
            </List>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg" sx={{ py: 5 }}>

        <Card className="bg-dark">
          <Grid container spacing={1}>
            <Grid size={{xs: 12, md: 8}}>
              <Logo color="white" />
              <List sx={{mt: 3}}>
                <ListItem sx={{px: 0, py: 1}}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <img src={Austria} width={42} height={42} alt="Made in Austria" />
                    <Box>
                      <p className="text-white">Made in Austria</p>
                      <p className="text-secondary">Proven by world leading industries</p>
                    </Box>
                  </Stack>
                </ListItem>
                <ListItem sx={{px: 0, py: 1}}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <img src={Europe} width={42} height={42} alt="GDPR & AI Act compliant" />
                    <Box>
                      <p className="text-white">GDPR &amp; AI Act compliant</p>
                      <p className="text-secondary">Securely hosted in the EU</p>
                    </Box>
                  </Stack>
                </ListItem>
              </List>
            </Grid>
            <Grid size={{xs: 12, md: 4}}>
              <p className="text-uppercase text-light text-secondary">Information</p>
              <List>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/terms" className="text-white">Terms of Service</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/privacy" className="text-white">Privacy Policy</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/beta" className="text-white">Beta Test Agreement</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/legal" className="text-white">Legal Notice</NavLink></ListItem>
                <ListItem sx={{px: 0, py: 0.5}}><NavLink to="/legal" className="text-white">Contact</NavLink></ListItem>
              </List>
            </Grid>
          </Grid>

          <Divider sx={{borderColor: 'var(--text-secondary) !important', my: 3, opacity: 0.5}} />

          <p className="text-secondary">
            &copy; Innomaze FlexCo
          </p>
        </Card>
      </Container>
    </footer>
  </>;
};

const featureTable = [
  {
    "criteria": "Lessons learned usability",
    "lessonice": "Specifically optimized for lessons learned",
    "chatgpt": "Very flexible, but lacks guidance",
    "copilot": "Good for standard Office tasks, not specialized for LL"
  },
  {
    "criteria": "Lessons learned capture",
    "lessonice": "Structured, workflow-based, throughout project lifecycle",
    "chatgpt": "spot-wise, no process guidance",
    "copilot": "Context-based, e.g., from Word/Teams/Planner data"
  },
  {
    "criteria": "Decision support",
    "lessonice": "Data-driven recommendations with impact evaluation",
    "chatgpt": "Hypothetical only via prompts",
    "copilot": "Not systematically available"
  },
  {
    "criteria": "Root cause anylasis",
    "lessonice": "Built-in, incl. visualization & categorization based on 5-Why, Fishbone",
    "chatgpt": "Ad-hoc, supported via manual dialog guidance",
    "copilot": "Only manual by user in tools like Excel/Word"
  },
  {
    "criteria": "Knowledge linking",
    "lessonice": "Automatic linking to project artifacts",
    "chatgpt": "Possible via manual prompting (e.g., 'refer to project X')",
    "copilot": "Manual linking or via SharePoint"
  },
  {
    "criteria": "Search & re-use ",
    "lessonice": "Semantic search, filtering, similarity analysis",
    "chatgpt": "Good in dialog ('Give me similar lessons from project Y')",
    "copilot": "Classic document search, no real re-use process"
  },
  {
    "criteria": "Integration into tools",
    "lessonice": "Seamless integration into common collaboration tools like MS Teams, Jira, Asana, etc.",
    "chatgpt": "Export/import possible, no native workflow",
    "copilot": "MS365 only"
  },
  {
    "criteria": "Analytics dashboard and data charts",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Categorized root causes & clustering",
    "lessonice": "Y",
    "chatgpt": "~",
    "copilot": "N"
  },
  {
    "criteria": "Visual root cause mapping",
    "lessonice": "Y",
    "chatgpt": "~",
    "copilot": "N"
  },
  {
    "criteria": "Risk prediction",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Trend analysis",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Blind spot analysis",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  },
  {
    "criteria": "Use as project team",
    "lessonice": "Y",
    "chatgpt": "N",
    "copilot": "N"
  }
];

const FaqItem = (props: { question: string, answer: string }) => {

  const [isOpen, shouldOpen] = useState(false);

  return <ListItem disablePadding>
    <Box>
      <Stack sx={{cursor: "pointer"}} direction="row" onClick={() => shouldOpen(!isOpen)} alignItems="center" justifyContent="space-between">
        <h3 className="text-white text-light">{props.question}</h3>
        { isOpen ? <ExpandMoreIcon color="secondary" /> : <KeyboardArrowRightIcon color="secondary" /> }
      </Stack>
      <Collapse in={isOpen}>
        <p className="text-secondary">{props.answer}</p>
      </Collapse>
      <Divider sx={{borderColor: 'var(--text-secondary) !important', my: 2, opacity: 0.5}} />
    </Box>
  </ListItem>
}

export default Landingpage;
